import { render, staticRenderFns } from "./Senderos.vue?vue&type=template&id=68be18ad&scoped=true"
import script from "./Senderos.vue?vue&type=script&lang=js"
export * from "./Senderos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68be18ad",
  null
  
)

export default component.exports